import { render, staticRenderFns } from "./ClaimItemsStats.vue?vue&type=template&id=3b16d90c&scoped=true&"
import script from "./ClaimItemsStats.vue?vue&type=script&lang=js&"
export * from "./ClaimItemsStats.vue?vue&type=script&lang=js&"
import style0 from "./ClaimItemsStats.vue?vue&type=style&index=0&id=3b16d90c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b16d90c",
  null
  
)

export default component.exports